import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NotificationsService } from "@services/notifications.service";
import { SetupWizardService } from "@services/setup-wizard.service";
import { tap } from "rxjs/operators";

enum TableColumns {
  CourseCode = "Course Code",
  Integration = "integration",
}

@Component({
  selector: "app-wizard-course-code",
  templateUrl: "./wizard-course-code.component.html",
  styleUrls: ["./wizard-course-code.component.scss", "../wizard-styles.scss"],
})
export class WizardCourseCodeComponent implements OnInit {
  public columns = TableColumns;
  public integrations$: any;
  public newCode: string = "";
  public isProcessing;
  public selectedIntegration;
  public tableHeaders = [TableColumns.CourseCode, TableColumns.Integration];
  public integrations;
  constructor(
    private wizardService: SetupWizardService,
    private notifications: NotificationsService,
    private cd: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.integrations$ = this.wizardService.getIntegrations$().pipe(
      tap(({ selectedIntegration }) => {
        this.selectedIntegration = selectedIntegration;
        this.cd.detectChanges();
      })
    );
  }

  get rows() {
    return this?.selectedIntegration?.value?.searchTerms || [];
  }

  get currentData() {
    return this?.selectedIntegration?.value?.searchTerms;
  }

  addNewInput() {
    if (
      this.selectedIntegration?.value?.searchTerms?.includes(this.newCode)
    ) {
      return this.notifications.popNotification("", "Duplicate match");
    }
    this.rows.push(this.newCode);
    this.newCode = "";
  }

  removeElement(index) {
    this.rows.splice(index, 1);
  }

  saveCourseCodes() {
    this.isProcessing = true;
  }
}
